type RtcLogLevel = 'info' | 'warn' | 'error';

type RtcLogEntry = {
  level: RtcLogLevel;
  message: string;
  data?: unknown;
  timestamp: string;
};

declare global {
  interface Window {
    __locsRtcLogs?: RtcLogEntry[];
  }
}

const MAX_RTC_LOGS = 500;
const RTC_LOG_STORAGE_KEY = 'locs-rtc-logs';

function toSerializableData(data: unknown) {
  if (data instanceof Error) {
    return {
      name: data.name,
      message: data.message,
      stack: data.stack,
    };
  }
  return data;
}

export function rtcLog(level: RtcLogLevel, message: string, data?: unknown) {
  const serializableData = toSerializableData(data);
  if (typeof window !== 'undefined') {
    const entry = {
      level,
      message,
      data: serializableData,
      timestamp: new Date().toISOString(),
    };
    const logs = window.__locsRtcLogs ?? [];
    logs.push(entry);
    if (logs.length > MAX_RTC_LOGS) {
      logs.splice(0, logs.length - MAX_RTC_LOGS);
    }
    window.__locsRtcLogs = logs;
    try {
      window.localStorage.setItem(RTC_LOG_STORAGE_KEY, JSON.stringify(logs));
    } catch {
      // Ignore storage quota or privacy-mode errors; console/window logs still work.
    }
  }

  const args = data === undefined
    ? [`[rtc] ${message}`]
    : [`[rtc] ${message} ${JSON.stringify(serializableData)}`];
  if (level === 'warn') {
    console.warn(...args);
    return;
  }
  if (level === 'error') {
    console.error(...args);
    return;
  }
  console.info(...args);
}
